module.exports = __webpack_public_path__ + "img/task-board-inquiry1.64a1e781.png";